import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Space,
  Button,
  DatePicker,
  Alert,
  Divider,
  Progress,
  Spin,
} from "antd";
import Icon, {
  CalendarFilled,
  EditOutlined,
  EllipsisOutlined,
  EyeOutlined,
  SettingOutlined,
  MedicineBoxOutlined,
  OrderedListOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import {
  BlankSpace,
  PageContainer,
  Xpagination,
  Xtable,
} from "../../component/Xcomponent";
import AppointmentView from "../Appointments/AppointmentView/AppointmentView";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../config.js";
// Style
import {
  EarningBookingWidget,
  Widget,
  WidgetBody,
  WidgetDescription,
  WidgetTitle,
  EarningBookingLeftDiv,
  EarningBookingRightDiv,
  EarningBookingVectorDiv,
  WidgetDiv,
  AppointmentWidget,
  BookingHeadingDiv,
  ViewAllButton,
  BookingHeading,
  BookingWidget,
  BookingWidgetDiv,
  BookingWidgetLeftDiv,
  BookingWidgetRightDiv,
  BookingWidgetLeftTopDiv,
  BookingWidgetLeftBottomDiv,
  BookingWidgetRightTopDiv,
  BookingWidgetRightBottomDiv,
  ArticleCard,
  ArticleTagCard,
  ArticleTagBody,
  ArticleTagTitleBody,
} from "./HomeStyle";

// Actions
import {
  getHomePageWidget,
  getHomePageWidgetReset,
} from "../../action/getHomePageWidgetAction";
import {
  getPatientAppointmentList,
  getPatientAppointmentListResetState,
} from "../../action/getPatientAppointmentListAction";
import {
  dateFormat,
  dateFormatMonthName,
  dateTimeFormat,
  dateTimeFormatMonthName,
  getDoctorActivate,
  s3_cdn,
  timeSlotFormat,
  getDoctorToken
} from "../../utils";

// Icons
import {
  CompleteAppointment,
  DotIcon,
  PatientIcon,
  TotalAppointment,
  Watch,
} from "../../component/CustomIcons";
import HeaderContext from "../../context/HeaderContext";
import { getArticleTags, getArticleTagsReset } from "../../action/getArticleTagsAction.js";

const Home = (props) => {
  // Variables
  const [view, setView] = useState({
    visible: false,
    id: null,
  });
  const {
    getHomePageWidget,
    getHomePageWidgetState,
    getHomePageWidgetReset,
    getPatientAppointmentList,
    getPatientAppointmentListState,
    getPatientAppointmentListResetState,
    getDoctorDetailState,
    getArticleTags,
    getArticleTagsReset,
    getArticleTagsState

  } = props;

  const [tableData, setTableData] = useState([]);
  const search = useLocation().search;
  const page = new URLSearchParams(search).get("page");
  const [pagination, setPagination] = useState({
    page: page ? page : 1,
    records: 10,
  });
  const [widget, setWidget] = useState({
    total_patient: 0,
    total_appointment: 0,
    total_completed_appointment: 0,
    total_earning: 0,
    total_booking: 0,
    upcoming_appointment: [],
    text_articles: [],
    video_articles: [],
    audio_articles: [],
  });

  const [activeFilterButton, setActiveFilterButton] = useState("pending");
  const [dateRange, setDateRange] = useState({ start_date: "", end_date: "" });
  const [monthlyEarning, setMonthlyEarning] = useState(0);
  const [monthlyBookings, setMonthlyBookings] = useState(0);
  const [loadingMonthlyData, setLoadingMonthlyData] = useState(false);
  const [articleTagList,setArticleTagList] = useState([])
  const columns = [
    {
      title: "Appointment No",
      dataIndex: "appointment_no",
      key: "appointment_no",
    },
    {
      title: "Appointment On",
      dataIndex: "appointment_date",
      key: "appointment_date",
    },
    {
      title: "Patient Name",
      dataIndex: "patient_name",
      key: "patient_name",
    },
    {
      title: "Booked Date",
      dataIndex: "booked_date",
      key: "booked_date",
    },
    // {
    //     title: "Action",
    //     dataIndex: "id",
    //     key: "action",
    //     width: 100,
    //     render: (id) => (
    //         <Space size="small">
    //             <Button size="small" shape="circle" icon={<EyeOutlined />} />
    //         </Space>
    //     ),
    // },
  ];
  const {setTitle} = useContext(HeaderContext);
  setTitle("Dashboard");
  // Callback
  useEffect(() => {
    getHomePageWidget();
    getArticleTags()
    // getPatientAppointmentList({ status: activeFilterButton })

    return () => {
      getHomePageWidgetReset();
      getPatientAppointmentListResetState();
      getArticleTagsReset()
    };
  }, []);

  useEffect(() => {
    if (getHomePageWidgetState.apiState === "success") {
      setWidget({
        total_patient: getHomePageWidgetState.data.total_patient,
        total_appointment: getHomePageWidgetState.data.total_appointment,
        total_completed_appointment:
          getHomePageWidgetState.data.total_completed_appointment,
        upcoming_appointment: getHomePageWidgetState.data.upcomingBookings,
        text_articles: getHomePageWidgetState.data.text_articles,
        video_articles: getHomePageWidgetState.data.video_articles,
        audio_articles: getHomePageWidgetState.data.audio_articles,
        total_earning:
          getHomePageWidgetState.data.total_earning[0]?.totalAmount,
        total_booking:
          getHomePageWidgetState.data.total_earning[0]?.totalBooking,
      });
    }
  }, [getHomePageWidgetState]);

  useEffect(() => {
    if (getArticleTagsState.apiState === "success") {
      console.log("getArticleTagsState", getArticleTagsState);
      setArticleTagList(getArticleTagsState?.list);
    }
  }, [getArticleTagsState]);

  useEffect(() => {
    if (getPatientAppointmentListState.apiState === "success") {
      let tableData = [];
      getPatientAppointmentListState.list.map((data) => {
        tableData.push({
          appointment_no: data.appointment_no,
          appointment_date: `${dateFormatMonthName(data.date)} ${timeSlotFormat(
            data.time_slot_start
          )} - ${timeSlotFormat(data.time_slot_end)}`,
          patient_name: data.some_one_else
            ? `${data.full_name} ${data.phone}`
            : data.patient_id
            ? `${data.patient_id?.name.firstName}  ${data.patient_id?.name.lastName} ${data.patient_id?.phone}`
            : "",
          booked_date: dateTimeFormatMonthName(data.createdAt),
          id: data._id,
        });
      });

      setTableData(tableData);
    }
  }, [getPatientAppointmentListState]);

  useEffect(() => {
    getPatientAppointmentList({
      status: activeFilterButton,
      page: pagination.page,
      records: pagination.records,
      ...dateRange,
    });
  }, [pagination, activeFilterButton, dateRange]);

  //Function
  const onChangeStatus = (status) => {
    setActiveFilterButton(status);
  };

  const handleDateRangeChange = (value, dateString) => {
    setDateRange({
      start_date: dateString[0]
        ? moment(dateString[0]).format("YYYY-MM-DD")
        : "",
      end_date: dateString[1] ? moment(dateString[1]).format("YYYY-MM-DD") : "",
    });
  };

  const getMonthlyData = async () => {
    try {
      setLoadingMonthlyData(true)
      const response = await axios.get(
        `${config.api.base_url}book-appointment/consultation-dashboard?from&to`, 
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
        }
      ).then((response)=>{
        setLoadingMonthlyData(false)
        setMonthlyEarning(response.data.data.earning_summary.total_earning);
        setMonthlyBookings(response.data.data.earning_summary.total_booking);
      })
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    getMonthlyData();
  }, []);

  return (
    <PageContainer>
      {/* <Row gutter={[20, 20]}>
        {getDoctorActivate() === "pending" && (
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <label style={{ color: "#A64FA6", fontSize: 18, fontWeight: 500 }}>
              Your account is under review.
            </label>
          </Col>
        )}
        {
          getDoctorDetailState.apiState=="success" && 
          getDoctorDetailState.data.is_dcp_activated=="Yes" &&
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <EarningBookingWidget loading={loadingMonthlyData}>
              <EarningBookingLeftDiv />
              <EarningBookingRightDiv />
              <EarningBookingVectorDiv>
                <div>
                  <p className="title widgetTitle">Earnings for the month</p>
                  <p className="money widgetTitle mt-1"><span style={{fontFamily:"initial"}}>₹</span> {monthlyEarning}</p>
                </div>
                <div>
                  <img className="homeEarning" src="./images/Vector.png" />
                </div>
              </EarningBookingVectorDiv>
            </EarningBookingWidget>
          </Col>
        }
        {
          getDoctorDetailState.apiState=="success" && 
          getDoctorDetailState.data.is_dcp_activated=="Yes" &&
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <EarningBookingWidget loading={loadingMonthlyData}>
              <EarningBookingLeftDiv />
              <EarningBookingRightDiv />
              <EarningBookingVectorDiv>
                <div>
                  <p className="title widgetTitle mb-1">Bookings for the month</p>
                  <p className="money widgetTitle">{monthlyBookings}</p>
                </div>
                <div>
                  <img className="homeEarning" src="./images/Vector.png" />
                </div>
              </EarningBookingVectorDiv>
            </EarningBookingWidget>
          </Col>
        }
      </Row>
      <BlankSpace /> */}
      <Row gutter={[20, 20]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <AppointmentWidget loading={getHomePageWidgetState.apiState=="loading"}>
            <Widget border={false}>
              <Progress
                format={() => <PatientIcon size={36} />}
                type="circle"
                strokeColor={{ "20%": "#71C9C1", "80%": "#5D6CB3" }}
                percent={(100 / 5000) * widget.total_patient}
                width={100}
                strokeWidth={8}
              />
              <WidgetBody>
                <WidgetDescription>{widget.total_patient}</WidgetDescription>
                <WidgetTitle>Total Patient</WidgetTitle>
              </WidgetBody>
            </Widget>
          </AppointmentWidget>
        </Col>
        {
          getDoctorDetailState.apiState=="success" && 
          getDoctorDetailState.data.is_dcp_activated=="Yes" &&
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <AppointmentWidget loading={getHomePageWidgetState.apiState=="loading"}>
              <Widget border={false}>
                <Progress
                  format={() => <TotalAppointment size={46} />}
                  type="circle"
                  strokeColor={{ "20%": "#BC25E7", "80%": "#6B62EE" }}
                  percent={(100 / 5000) * widget.total_appointment}
                  width={100}
                  strokeWidth={8}
                />
                <WidgetBody>
                  <WidgetDescription>
                    {widget.total_appointment}
                  </WidgetDescription>
                  <WidgetTitle>Total Appointments</WidgetTitle>
                </WidgetBody>
              </Widget>
            </AppointmentWidget>
          </Col>
        }
        {
          getDoctorDetailState.apiState=="success" && 
          getDoctorDetailState.data.is_dcp_activated=="Yes" &&
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <AppointmentWidget loading={getHomePageWidgetState.apiState=="loading"}>
              <Widget border={false}>
                <Progress
                  format={() => <CompleteAppointment size={46} />}
                  type="circle"
                  strokeColor={{ "20%": "#6B62EE", "80%": "#D6ADFF" }}
                  percent={(100 / 5000) * widget.total_completed_appointment}
                  width={100}
                  strokeWidth={8}
                />
                <WidgetBody>
                  <WidgetDescription>
                    {widget.total_completed_appointment}
                  </WidgetDescription>
                  <WidgetTitle>Appointment Completed</WidgetTitle>
                </WidgetBody>
              </Widget>
            </AppointmentWidget>
          </Col>
        }

      </Row>
      <BlankSpace />
      {/* request by lilac */}
      {articleTagList.length > 0 && (
        <>
          <BlankSpace />
          <BookingHeadingDiv>
            <BookingHeading>
              Fetal Medicine Foundation (UK) Resources
            </BookingHeading>
            {/* <Link to="/article-read">
              <ViewAllButton type="ghost" shape="round">
                View All
              </ViewAllButton>
            </Link> */}
          </BookingHeadingDiv>
          <BlankSpace />
          <Row gutter={[20, 20]}>
            {articleTagList.map((item, index) => {
              return (
                <>
                  <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Link
                      to={{
                        pathname: "/article-read",
                        state: { key: item.key },
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      <ArticleTagCard>
                        <ArticleTagBody border={false}>
                          <img
                            style={{
                              maxHeight: "20%", // Adjusted to fit better
                              maxWidth: "20%", // Adjusted to fit better
                              objectFit: "contain",
                              marginBottom: "20px",
                            }}
                            alt="example"
                            src={`${item.icon_url}`}
                          />

                          <ArticleTagTitleBody>
                            <WidgetTitle>{item.title}</WidgetTitle>
                          </ArticleTagTitleBody>
                        </ArticleTagBody>
                      </ArticleTagCard>
                    </Link>
                  </Col>
                </>
              );
            })}
          </Row>
          <BlankSpace />
        </>
      )}

      {/* request by lilac */}
      {getDoctorDetailState.apiState=="success" && getDoctorDetailState.data.is_dcp_activated=="Yes" && widget.upcoming_appointment.length > 0 && (
        <>
          <BookingHeadingDiv>
            <BookingHeading>Upcoming Appointment</BookingHeading>
            <Link to={`/appointment?type=Upcoimg`}>
              <ViewAllButton type="ghost" shape="round">
                View All
              </ViewAllButton>
            </Link>
          </BookingHeadingDiv>
          <BlankSpace />
          <Row gutter={[22, 22]}>
            {widget.upcoming_appointment.map((data) => (
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={8}
                onClick={() => setView({ id: data._id, visible: true })}
              >
                <BookingWidget>
                  <BookingWidgetDiv>
                    <BookingWidgetLeftDiv>
                      <BookingWidgetLeftTopDiv>
                        <p>{moment(data.date).format("MMM")}</p>
                        <p className="day">{moment(data.date).format("DD")}</p>
                      </BookingWidgetLeftTopDiv>
                      <BookingWidgetLeftBottomDiv>
                        {moment(data.date).format("YYYY")}
                      </BookingWidgetLeftBottomDiv>
                    </BookingWidgetLeftDiv>
                    <BookingWidgetRightDiv>
                      <BookingWidgetRightTopDiv>
                        <p className="name">
                          {data.patient_id?.name.firstName}{" "}
                          {data.patient_id?.name.lastName}
                        </p>
                        <p className="appno">{data.appointment_no}</p>
                        {/* className="time upcommingTime" */}
                        <p className="time">
                          <Watch />
                          <label
                            style={{ paddingLeft: 6, color: "#7A2F9C" }}
                          >{`${timeSlotFormat(
                            data.time_slot_start
                          )} - ${timeSlotFormat(data.time_slot_end)}`}</label>
                        </p>
                        {/* <Divider plain></Divider> */}
                      </BookingWidgetRightTopDiv>
                      <BookingWidgetRightBottomDiv>
                        <p>
                          Booked on :{" "}
                          {moment(data.createdAt).format("DD MMM YYYY hh:mm A")}
                        </p>
                      </BookingWidgetRightBottomDiv>
                    </BookingWidgetRightDiv>
                  </BookingWidgetDiv>
                </BookingWidget>
              </Col>
            ))}
          </Row>
          <BlankSpace />
        </>
      )}
      {/* {widget.text_articles.length > 0 && (
        <>
          <BookingHeadingDiv>
            <BookingHeading>Blogs</BookingHeading>
            <Link to="/article-read">
              <ViewAllButton type="ghost" shape="round">
                View All
              </ViewAllButton>
            </Link>
          </BookingHeadingDiv>
          <BlankSpace />
            {getHomePageWidgetState.apiState =="loaading"?
              <div style={{ textAlign: "center" }}>
                  <Spin size="large" tip="Loading Blogs..."/>
              </div>
              :
              widget.text_articles.length > 0 ?
              <Row gutter={[20, 20]}>
            {widget.text_articles.map((data) => (
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Link to={`article-detail/${data.slug}`}>
                      <ArticleCard
                        cover={
                          <img
                            className="cardImage"
                            alt="example"
                            src={`${s3_cdn()}article/${data.image_path}`}
                          />
                        }
                      >
                        <div className="description">
                          <p>{data.title}</p>
                          <div className="views">
                            <span>
                              {moment(data.createdAt).format("Do MMM YYYY")}
                            </span>
                            <span style={{ margin: "0 2px" }}>
                              <DotIcon size="6" height="6" />
                            </span>
                            <EyeOutlined />
                            <span>{data.views} views</span>
                          </div>
                        </div>
                      </ArticleCard>
                    </Link>
                </Col> 
              ))}
              </Row>
              :(
                <div style={{ textAlign: "center" }}>
                  <svg
                    class="ant-empty-img-default"
                    width="120"
                    height="80"
                    viewBox="0 0 184 152"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <g transform="translate(24 31.67)">
                        <ellipse
                          class="ant-empty-img-default-ellipse"
                          cx="67.797"
                          cy="106.89"
                          rx="67.797"
                          ry="12.668"
                        ></ellipse>
                        <path
                          class="ant-empty-img-default-path-1"
                          d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-2"
                          d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
                          transform="translate(13.56)"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-3"
                          d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-4"
                          d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                  <p>no data</p>
                </div>
              )}
              <BlankSpace />
            </>
          )}
      {widget.video_articles.length > 0 && (
        <>
          <BookingHeadingDiv>
            <BookingHeading>Video</BookingHeading>
            <Link to="/article-watch">
              <ViewAllButton type="ghost" shape="round">
                View All
              </ViewAllButton>
            </Link>
          </BookingHeadingDiv>
          <BlankSpace />
          {getHomePageWidgetState.apiState=="loading"?
              <div style={{ textAlign: "center" }}>
                  <Spin size="large" tip="Loading Videos..."/>
              </div>
              :
              widget.text_articles.length > 0 ?
              <Row gutter={[20, 20]}>
              {widget.video_articles.map((data) => (
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Link to={`article-detail/${data.slug}`}>
                      <ArticleCard
                        cover={
                          <img
                            className="cardImage"
                            alt="example"
                            src={`${s3_cdn()}article/${data.image_path}`}
                          />
                        }
                      >
                        <div className="description">
                          <p>{data.title}</p>
                          <div className="views">
                            <span>
                              {moment(data.createdAt).format("Do MMM YYYY")}
                            </span>
                            <span style={{ margin: "0 2px" }}>
                              <DotIcon size="6" height="6" />
                            </span>
                            <EyeOutlined />
                            <span>{data.views} views</span>
                          </div>
                        </div>
                      </ArticleCard>
                    </Link>
                  </Col>
              ))}
                </Row>
              :(
                <div style={{ textAlign: "center" }}>
                  <svg
                    class="ant-empty-img-default"
                    width="120"
                    height="80"
                    viewBox="0 0 184 152"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <g transform="translate(24 31.67)">
                        <ellipse
                          class="ant-empty-img-default-ellipse"
                          cx="67.797"
                          cy="106.89"
                          rx="67.797"
                          ry="12.668"
                        ></ellipse>
                        <path
                          class="ant-empty-img-default-path-1"
                          d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-2"
                          d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
                          transform="translate(13.56)"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-3"
                          d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                        ></path>
                        <path
                          class="ant-empty-img-default-path-4"
                          d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                  <p>no data</p>
                </div>
              )}
          
          <BlankSpace />
        </>
      )} */}
      {/* {widget.audio_articles.length > 0 && (
        <>
          <BookingHeadingDiv>
            <BookingHeading>Audio</BookingHeading>
            <Link to="/article-listen">
              <ViewAllButton type="ghost" shape="round">
                View All
              </ViewAllButton>
            </Link>
          </BookingHeadingDiv>
          <BlankSpace />
          <Row gutter={[20, 20]}>
            {widget.audio_articles.map((data) => (
              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <Link to={`article-detail/${data.slug}`}>
                  <ArticleCard
                    cover={
                      <img
                        className="cardImage"
                        alt="example"
                        src={`${s3_cdn()}article/${data.image_path}`}
                      />
                    }
                  >
                    <div className="description">
                      <p>{data.title}</p>
                      <div className="views">
                        <span>
                          {moment(data.createdAt).format("Do MMM YYYY")}
                        </span>
                        <span style={{ margin: "0 2px" }}>
                          <DotIcon size="6" height="6" />
                        </span>
                        <EyeOutlined />
                        <span>{data.views} views</span>
                      </div>
                    </div>
                  </ArticleCard>
                </Link>
              </Col>
            ))}
          </Row>
          <BlankSpace />
        </>
      )} */}
      {/* <div style={{ width: '100%', backgroundColor: '#fff' }}>
                <Card title="Patient Appointment" bordered={false}>
                    <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <Space>
                                <Button type={activeFilterButton === 'pending' ? 'primary' : 'default'} shape="round" onClick={() => onChangeStatus('pending')}>New</Button>
                                <Button type={activeFilterButton === 'cancelled' ? 'primary' : 'default'} shape="round" onClick={() => onChangeStatus('cancelled')}>Cancelled</Button>
                                <Button type={activeFilterButton === 'not attended' ? 'primary' : 'default'} shape="round" onClick={() => onChangeStatus('not attended')}>Not Attended</Button>
                            </Space>
                        </div>
                        <div>
                            <RangePicker
                                onChange={handleDateRangeChange}
                                // defaultValue={[moment('2021/01/01', dateFormat), moment('2021/01/01', dateFormat)]}
                                // value={dateRange}
                                format={"DD-MMM-YYYY"}
                            />
                        </div>
                    </div>
                    <BlankSpace />
                    <Xtable bordered columns={columns} dataSource={tableData} pagination={false} scroll={{ x: 768 }} loading={getPatientAppointmentListState.apiState === "loading"} />
                    <Xpagination
                        pageSizeOptions={["10", "25", "50", "100", "500"]}
                        showSizeChanger
                        total={getPatientAppointmentListState.pagination.total_records}
                        onChange={(page, pageSize) =>
                            setPagination({ page: page, records: pageSize })
                        }
                        current={pagination.page}
                        defaultPageSize={pagination.records}
                        showTotal={(total, range) =>
                            `${range[0]}-${range[1]} of ${total} items`
                        }
                    />
                </Card>
            </div> */}
      <AppointmentView
        id={view.id}
        visible={view.visible}
        onClose={() => setView({ visible: false, id: null })}
      />
    </PageContainer>
  );
};
const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getHomePageWidgetState: state.getHomePageWidget,
  getPatientAppointmentListState: state.getPatientAppointmentList,
  getArticleTagsState:state.getArticleTags,
});

const mapDispatchToProps = (dispatch) => ({
  getHomePageWidget: (params) => dispatch(getHomePageWidget(params)),
  getHomePageWidgetReset: () => dispatch(getHomePageWidgetReset()),
  getPatientAppointmentList: (params) =>
    dispatch(getPatientAppointmentList(params)),
  getPatientAppointmentListResetState: () =>
    dispatch(getPatientAppointmentListResetState()),
  getArticleTags:(params) => dispatch(getArticleTags(params)),
  getArticleTagsReset:()=>dispatch(getArticleTagsReset())
 });

export default connect(mapStateToProps, mapDispatchToProps)(Home);
